import "../../styles/mydonnad/index.scss";
import {SmartComponentManager} from "smart-component-js";
import DefaultCtrl from "./controllers/DefaultCtrl";
import HeaderMdComponent from "./components/HeaderMdComponent";
import SurveyComponent from "./components/SurveyComponent";
import CompleteProfileComponent from "./components/CompleteProfileComponent";
import ProfileComponent from "./components/ProfileComponent";
import ReceiptComponent from "./components/ReceiptComponent";
import InviteFriendCodeComponent from "./components/InviteFriendCodeComponent";
import InviteFriendModalComponent from "./components/InviteFriendModalComponent";
import SubscribeComponent from "./components/SubscribeComponent";
import MemberGetMemberModalComponent from "./components/MemberGetMemberModalComponent";
import OnBoardingModalComponent from "./components/OnBoardingModalComponent";
import BannerUploadComponent from "./components/BannerUploadComponent";
import TelInputComponent from "./components/TelInputComponent";
import CouponComponent from "./components/CouponComponent";
import MissionTabsComponent from "./components/MissionTabsComponent";
import ScreensetComponent from "../common/ScreensetComponent";
import ActivitiesListComponent from "./components/ActivitiesListComponent";
import PrizeDetailComponent from "./components/PrizeDetailComponent";
import PrizesFilterComponent from "./components/PrizesFilterComponent";
import ReengagementModalComponent from "./components/ReengagementModalComponent";
import FrequencyMissionModalComponent from "./components/FrequencyMissionModalComponent";
import PartecipaIniziativaModalComponent from "./components/PartecipaIniziativaModalComponent";
import CheckRedirectComponent from "../common/CheckRedirectComponent";
import LinkParamsComponent from "./components/LinkParamsComponent";
import QuizComponent from "./components/QuizComponent";


SmartComponentManager.registerComponents({
    DefaultCtrl,
    HeaderMdComponent,
    SurveyComponent,
    CompleteProfileComponent,
    ProfileComponent,
    ReceiptComponent,
    InviteFriendCodeComponent,
    InviteFriendModalComponent,
    SubscribeComponent,
    MemberGetMemberModalComponent,
    OnBoardingModalComponent,
    BannerUploadComponent,
    TelInputComponent,
    CouponComponent,
    MissionTabsComponent,
    ScreensetComponent,
    ActivitiesListComponent,
    PrizeDetailComponent,
    PrizesFilterComponent,
    ReengagementModalComponent,
    FrequencyMissionModalComponent,
    PartecipaIniziativaModalComponent,
    CheckRedirectComponent,
    LinkParamsComponent,
    QuizComponent
});

document.addEventListener("DOMContentLoaded", () => {
    let body = document.querySelector('body [component="DefaultCtrl"]');
    SmartComponentManager.initComponentByName(body, 'DefaultCtrl');
});
